import classNames from "classnames";
import Styles from "./Service.module.scss";
import Navbar from "../../Component/Navbar/Navbar";
import SubTitle from "../../Component/Text/SubTitle";
import Footer from "../../Component/Footer/Footer";

const ShortTermTemporary = () => {
  return (
    <div>
      <Navbar />
      <div style={{ padding: "8vh" }} className={classNames("container")}>
        <SubTitle text={`短期臨托`} />
        <div className={classNames(Styles.service__item)}>
          <h5 className={classNames(Styles.service__item__title)}>
            {" "}
            身心障礙者臨時及短期照顧服務
          </h5>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            服務對象{" "}
          </h6>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>無設籍限制</li>
              <li>具有身心障礙證明者</li>
              <li>具有身心障礙證明者，外籍看護休假者</li>
              <li>獨居(僅與外籍看護同住)</li>
            </ul>
          </div>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            服務項目
          </h6>

          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>協助膳食</li>
              <li>簡易身體照顧服務</li>
              <li>臨時性之陪同就醫</li>
              <li>讀報及文書協助</li>
            </ul>
          </div>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            服務方式
          </h6>
          <p className={classNames(Styles.service__item__param)}>
            分為以下兩種服務需依照服務對象混合搭配使用：
          </p>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>臨時照顧：服務方式為居家式、社區式服務</li>
              <li>短期照顧：服務方式為連續受託</li>
            </ul>
          </div>

          <h6 className={classNames(Styles.service__item__subtitle)}>
            申請窗口
          </h6>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>預約時間週一至週五：上午08:00-12:00、下午13:00-1700</li>
              <li>電話預約：03-8530330 #18 李社工師</li>
              <li>LINE預約：0905832717</li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
export default ShortTermTemporary;
